import React, { useEffect, memo, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';

import { CONTEXT } from '../config';
import { logging } from '../actions/log';
import { changeClass, hasClass } from '../utils/utils'
import { setInTimeInstalledSoft } from '../actions/layout';

import styles from './InstDonePop.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInTimeInstSoft = createSelector(
  state => state.layout,
  layout => layout.inTimeInstSoft,
);


export default memo(() => {
  const dispatch = useDispatch();
  const inTimeInstSoft = useSelector(selectInTimeInstSoft);
  const logInfoData = useSelector(selectLogInfo);

  const instDonePopEL = useRef(null);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Installation',
        label: '',
        param2: {
          source: 'Installation',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [])

  useEffect(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'I',
          action: 'Installation',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
    }
  }, [dispatch, inTimeInstSoft])

  useEffect(() => {
    if (
      inTimeInstSoft &&
      inTimeInstSoft.appInfo) 
    {
      runPop(inTimeInstSoft, instDonePopEL);
    } else if (instDonePopEL && instDonePopEL.current) {
      changeClass(instDonePopEL.current, styles.instDonePop_fadeIn, styles.instDonePop_fadeOut);
    }
  }, [dispatch, inTimeInstSoft]);

  const runPop = useCallback((inTimeInstSoftData, instDonePopELData) => {
    setTimeout(() => {
      if (+new Date() - window.inTimeInstSoftTime > 10 * 1000) {
        if (inTimeInstSoft &&
          inTimeInstSoft.appInfo &&
          instDonePopEL &&
          instDonePopEL.current) {
          changeClass(instDonePopEL.current, styles.instDonePop_fadeOut, styles.instDonePop_fadeIn);
        }
      } else {
        runPop(inTimeInstSoftData, instDonePopELData)
      }
    }, 1000)
  }, [inTimeInstSoft, instDonePopEL])

  const onAnimationEndFadeOut = useCallback(() => {
    if (
      inTimeInstSoft &&
      inTimeInstSoft.appInfo &&
      instDonePopEL &&
      instDonePopEL.current &&
      hasClass(instDonePopEL.current, styles.instDonePop_fadeOut)
    ) {
      dispatch(setInTimeInstalledSoft(null))
    }
  }, [dispatch, instDonePopEL, inTimeInstSoft])

  const handleLink = useCallback(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'C',
          action: 'Installation',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
      onColsePop()
    }
  }, [dispatch, logInfoData, inTimeInstSoft])

  const onColsePop = useCallback(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'C',
          action: 'Installation_Close',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
      changeClass(instDonePopEL.current, styles.instDonePop_fadeOut, styles.instDonePop_fadeIn);
      dispatch(setInTimeInstalledSoft(null))
    }
  }, [dispatch, logInfoData, instDonePopEL])

  return (
    inTimeInstSoft && inTimeInstSoft.appInfo && (
    <div className={styles.instDonePop_fadeIn} ref={instDonePopEL} onAnimationEnd={() => onAnimationEndFadeOut()}>
      <div className={styles.instDonePop_icon}>
        <Link
          to={{ pathname: `${CONTEXT}/uninstall` }}
          onClick={() => {
            handleLink();
          }}
        >
          <img className={styles.instDonePop_icon_img} src={inTimeInstSoft.appInfo.logoFile} alt="img"/>
        </Link>
        <div className={styles.instDonePop_icon_alogo}/>
      </div>
      <Link
        className={styles.instDonePop_info}
        to={{ pathname: `${CONTEXT}/uninstall` }}
        onClick={() => {
          handleLink();
        }}
      >
        <span className={styles.instDonePop_info_soft}>{inTimeInstSoft.appInfo.softName}</span>
        <span className={styles.instDonePop_info_phone}>手机版</span>
        <span className={styles.instDonePop_info_desc}>安装完成</span>
      </Link>
      <div className={styles.instDonePop_close} onClick={() => onColsePop()}/>
    </div>
    )
  );
});
